import React from "react";
import { RecommendationProjectTypeEnum } from "../../../types";

interface TagButtonsProps {
  tags: RecommendationProjectTypeEnum[];
  selectedTag?: RecommendationProjectTypeEnum;
  onTagClick?: (tag: RecommendationProjectTypeEnum) => void;
}

const TagButtons: React.FC<TagButtonsProps> = ({ tags, selectedTag, onTagClick }) => {
  return (
    <div className="flex w-min gap-2 rounded-tr-lg bg-deep-purple-50 px-4 pt-2">
      {tags.map((tag) => {
        const isSelected = tag === selectedTag;

        return (
          <span
            key={tag}
            onClick={() => onTagClick?.(tag)}
            className={`inline-block cursor-pointer rounded-md px-3 py-1 text-sm font-medium transition
              ${
                isSelected
                  ? "bg-gray-100 text-black shadow"
                  : "bg-transparent text-gray-700 hover:bg-gray-100"
              }`}
          >
            {tag}
          </span>
        );
      })}
    </div>
  );
};

export default TagButtons;
